export default __webpack_public_path__ + "static/media/polaroid_PlymouthSciencePark.aaf19909.png";